export default __webpack_public_path__ + "static/media/calender.9b5af087.svg";